/**
 * Google Maps Optimizer Overlay Widget
 * Provides monitoring and toggle functionality for Google Maps optimizations
 */

import('../../services/google-maps-optimizer.js');

function GMapsOptimizerOverlay() {
  const self = this;
  self.optimizer = null;
  self.isVisible = false;
  self.updateInterval = null;
  
  // Wait for the optimizer to be available
  self.waitForOptimizer = function() {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait time
      
      const checkOptimizer = () => {
        if (window.googleMapsOptimizer) {
          self.optimizer = window.googleMapsOptimizer;
          resolve(self.optimizer);
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkOptimizer, 100);
        } else {
          reject(new Error('Google Maps Optimizer not available after 5 seconds'));
        }
      };
      
      checkOptimizer();
    });
  };

  // Create overlay HTML
  self.createOverlay = function() {
    if (!self.optimizer) {
      console.error('Cannot create overlay - optimizer not available');
      return;
    }
    
    const overlayHtml = `
      <div id="gmaps-optimizer-overlay" class="gmaps-optimizer-overlay">
        <div class="overlay-header">
          <div class="overlay-title">
            <svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            Maps Optimizer
          </div>
          <div class="overlay-actions">
            <button class="toggle-btn" data-action="minimize">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 12l6-6 6 6H6z"/>
              </svg>
            </button>
            <button class="toggle-btn" data-action="close">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.88c-.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.88-4.89c.39-.39.39-1.02 0-1.41z"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="overlay-content">
          <div class="optimization-toggle">
            <label class="toggle-switch">
              <input type="checkbox" id="optimization-enabled" ${self.optimizer.isOptimizationEnabled() ? 'checked' : ''}>
              <span class="slider"></span>
            </label>
            <span class="toggle-label">Enable Optimization</span>
          </div>
          
          <div class="stats-section">
            <div class="stat-row">
              <span class="stat-label">Status:</span>
              <span class="stat-value status" id="optimization-status">
                ${self.optimizer.isOptimizationEnabled() ? 'Enabled' : 'Disabled'}
              </span>
            </div>
            <div class="stat-row">
              <span class="stat-label">API Calls:</span>
              <span class="stat-value" id="api-calls">0</span>
            </div>
            <div class="stat-row">
              <span class="stat-label">Calls Saved:</span>
              <span class="stat-value saved" id="calls-saved">0</span>
            </div>
            <div class="stat-row">
              <span class="stat-label">Session Tokens:</span>
              <span class="stat-value" id="session-tokens">0/0</span>
            </div>
            <div class="stat-row">
              <span class="stat-label">Savings:</span>
              <span class="stat-value savings" id="savings-percentage">0%</span>
            </div>
          </div>

          <div class="actions-section">
            <button class="action-btn reset-btn" data-action="reset">Reset Stats</button>
            <button class="action-btn clear-btn" data-action="clear">Clear Cache</button>
          </div>
        </div>
        <div class="overlay-minimized">
          <div class="minimized-content">
            <svg class="icon" width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            <span class="minimized-savings">0%</span>
          </div>
        </div>
      </div>
    `;

    // Remove existing overlay if present
    $('#gmaps-optimizer-overlay').remove();

    // Add overlay to body
    $('body').append(overlayHtml);
    
    // Bind events
    self.bindEvents();
    
    // Start updating stats
    self.startStatsUpdate();
  };

  // Bind event handlers
  self.bindEvents = function() {
    const $overlay = $('#gmaps-optimizer-overlay');

    // Toggle optimization
    $overlay.find('#optimization-enabled').on('change', function() {
      if (!self.optimizer) return;
      
      const enabled = $(this).is(':checked');
      if(enabled !== self.optimizer.isOptimizationEnabled()) {
        self.optimizer.toggleOptimization();
        self.updateStatus();
      }
    });

    // Minimize/expand toggle
    $overlay.find('[data-action="minimize"]').on('click', function() {
      $overlay.toggleClass('minimized');
      const isMinimized = $overlay.hasClass('minimized');
      $(this).find('svg path').attr('d', isMinimized ? 
        'M6 18l6-6 6 6H6z' : 'M6 12l6-6 6 6H6z'
      );
    });

    // Close overlay
    $overlay.find('[data-action="close"]').on('click', function() {
      self.hide();
    });

    // Expand from minimized state
    $overlay.find('.overlay-minimized').on('click', function() {
      $overlay.removeClass('minimized');
      $overlay.find('[data-action="minimize"] svg path').attr('d', 'M6 12l6-6 6 6H6z');
    });

    // Reset stats
    $overlay.find('[data-action="reset"]').on('click', function() {
      if (!self.optimizer) return;
      
      if(confirm('Are you sure you want to reset all statistics?')) {
        self.optimizer.resetStats();
        self.updateStats();
      }
    });

    // Clear cache
    $overlay.find('[data-action="clear"]').on('click', function() {
      if (!self.optimizer) return;
      
      self.optimizer.clearCaches();
      alert('Cache cleared successfully!');
    });

    // Listen for optimization toggle events
    window.addEventListener('gmapsOptimizationToggled', (event) => {
      self.updateStatus();
    });
  };

  // Update optimization status
  self.updateStatus = function() {
    if (!self.optimizer) return;
    
    const enabled = self.optimizer.isOptimizationEnabled();
    $('#optimization-enabled').prop('checked', enabled);
    $('#optimization-status')
      .text(enabled ? 'Enabled' : 'Disabled')
      .removeClass('enabled disabled')
      .addClass(enabled ? 'enabled' : 'disabled');
  };

  // Update statistics display
  self.updateStats = function() {
    if (!self.optimizer) return;
    
    const stats = self.optimizer.getUsageStats();
    
    $('#api-calls').text(stats.placesApiCalls);
    $('#calls-saved').text(stats.placesApiCallsSaved);
    $('#session-tokens').text(`${stats.sessionTokensUsed || 0}/${stats.sessionTokensCreated || 0}`);
    $('#savings-percentage').text(stats.savingsPercentage + '%');
    
    // Update minimized display
    $('.minimized-savings').text(stats.savingsPercentage + '%');
    
    // Update colors based on savings
    const savingsElement = $('#savings-percentage');
    savingsElement.removeClass('low medium high');
    if (stats.savingsPercentage >= 50) {
      savingsElement.addClass('high');
    } else if (stats.savingsPercentage >= 25) {
      savingsElement.addClass('medium');
    } else {
      savingsElement.addClass('low');
    }
    
    // Update session token display colors
    const sessionElement = $('#session-tokens');
    sessionElement.removeClass('efficient unused');
    const efficiency = stats.sessionTokensCreated > 0 ? (stats.sessionTokensUsed / stats.sessionTokensCreated) : 0;
    if (efficiency >= 0.8) {
      sessionElement.addClass('efficient');
    } else if (efficiency < 0.5 && stats.sessionTokensCreated > 0) {
      sessionElement.addClass('unused');
    }
  };

  // Start periodic stats updates
  self.startStatsUpdate = function() {
    self.updateStats();
    self.updateInterval = setInterval(self.updateStats, 2000); // Update every 2 seconds
  };

  // Stop periodic stats updates
  self.stopStatsUpdate = function() {
    if (self.updateInterval) {
      clearInterval(self.updateInterval);
      self.updateInterval = null;
    }
  };

  // Show overlay
  self.show = function() {
    if (!self.isVisible) {
      // Wait for optimizer to be available before creating overlay
      self.waitForOptimizer()
        .then(() => {
          self.createOverlay();
          self.isVisible = true;
          
          // Add show class after small delay for animation
          setTimeout(() => {
            $('#gmaps-optimizer-overlay').addClass('show');
          }, 10);
        })
        .catch(error => {
          console.error('Failed to show overlay:', error);
        });
    }
  };

  // Hide overlay
  self.hide = function() {
    if (self.isVisible) {
      const $overlay = $('#gmaps-optimizer-overlay');
      $overlay.removeClass('show');
      
      setTimeout(() => {
        $overlay.remove();
        self.stopStatsUpdate();
        self.isVisible = false;
      }, 300);
    }
  };

  // Toggle overlay visibility
  self.toggle = function() {
    if (self.isVisible) {
      self.hide();
    } else {
      self.show();
    }
  };
}

// Initialize global instance
$(document).ready(function() {
  window.gmapsOptimizerOverlay = new GMapsOptimizerOverlay();

  // Add keyboard shortcut (Ctrl+Shift+M) to toggle overlay
  $(document).on('keydown', function(e) {
    if (e.ctrlKey && e.shiftKey && e.keyCode === 77) { // Ctrl+Shift+M
      e.preventDefault();
      window.gmapsOptimizerOverlay.toggle();
    }
  });

  // Auto-show overlay if optimization is enabled and there are stats to show
  setTimeout(() => {
    const optimizer = window.googleMapsOptimizer;
    if (optimizer) {
      const stats = optimizer.getUsageStats();
      
      // Show overlay if there's been API activity
      if (stats.placesApiCalls > 0 || stats.placesApiCallsSaved > 0) {
        window.gmapsOptimizerOverlay.show();
      }
    } else {
      console.warn('Google Maps Optimizer not available - overlay will not show');
    }
  }, 3000); // Wait 3 seconds after page load
});

export default GMapsOptimizerOverlay; 